import { QueryResultResource } from "../../models/query-result-resource";
import { Query } from "./query";
import { IQueryLoadConfiguration } from "./query-load-configuration";
import { ScrollRequest } from "./scroll-request";

/**
 * Helper to query and requesting minimal schemas.
 */
export interface ISchemaQuerying {
    /**
     * Executes a query.
     * @param query - The query to execute
     * @param loadConfiguration - The load configuration
     */
    queryWithSchemaAsync(query: Query, loadConfiguration: IQueryLoadConfiguration): Promise<QueryResultResource>;

    /**
     * Executes a scroll.
     * @param scrollRequest - The scroll info
     */
    scrollWithSchemaAsync(scrollRequest: ScrollRequest): Promise<QueryResultResource>;
}
